export default class DriveNotStarted extends Error {
    constructor() {
        super("Drive not started");
    }
}
